/**
 * JSAPI instance
 */
import { SET_API } from "../actionTypes.js";
import { replaceReducer } from "./common/index.js";
export default replaceReducer(SET_API, null);
//# sourceMappingURL=api.js.map